import { SpecData, Advisor, Transportation, DepartmentSpec, ServiceDocsData } from './Specs';

export const BlankAddress = {
    contactCity: '',
    contactCountry: '',
    contactCounty: '',
    contactState: '',
    contactStrNum: '',
    contactStreet: '',
    contactZip: '',
};

export const BlankDeptSpec: DepartmentSpec = {
    Advisors: [
        {
            advisorNum: '',
            advisorName: '',
            advisorPhone: '',
            advisorImage: '',
            defaultFlag: false,
        },
    ],
    Transportation: [],
    addtnlInfo: '',
    addtnlInfoEN: '',
    addtnlInfoFR: '',
    advisorOption: '',
    advisorOptionEN: '',
    advisorOptionFR: '',
    allTimesOption: false,
    allwAdvChng: '',
    autoCnfrmAppt: '',
    cntctHrsClose1: [''],
    cntctHrsClose2: [''],
    cntctHrsClose3: [''],
    cntctHrsOpen1: [''],
    cntctHrsOpen2: [''],
    cntctHrsOpen3: [''],
    // comingClosures: '',
    comingClosures: [''],
    confMessage: '',
    confMessageEN: '',
    confMessageFR: '',
    contactAddr: BlankAddress,
    contactEmail: '',
    contactExt: '',
    contactPhnNum: '',
    contactWebNme: '',
    custUpdateEml: '',
    defAdvOption: '',
    defAdvisorNum: '',
    defTransOption: '',
    defTranspValue: '',
    dispPhoneSel: '',
    dmsAction: [],
    dmsComplete: [],
    dmsCompleteEN: [],
    dmsCompleteFR: [],
    dmsInProgress: [],
    dmsInProgressEN: [],
    dmsInProgressFR: [],
    dmsNotStarted: [],
    dmsNotStartedEN: [],
    dmsNotStartedFR: [],
    dmsWebTitle: [],
    dmsWebTitleEN: [],
    dmsWebTitleFR: [],
    // endTime: '',
    maintMenuDisc: '',
    maintMenuDiscEN: '',
    maintMenuDiscFR: '',
    recTimesCtgry: '',
    recTimesDefCnt: '',
    recommTimes: '',
    maintMenuDiscFlg: '',
    requireConsFlg: '',
    requireConsMsg: '',
    requireConsMsgFR: '',
    requireConsMsgEN: '',
    disclaimerMsg: '',
    disclaimerMsgEN: '',
    disclaimerMsgFR: '',
    // shopClos1: '',
    // shopClose2: '',
    // shopOpen1: '',
    // shopOpen2: '',
    shwCustPrice: '',
    shwIntrnlLines: '',
    shwLinesROhst: '',
    // startTime: '',
    timeOfDay: [],
    shopHours: [],
    useDealerDisc: '',
    webLeadTimeHrs: '',
    anyAdvDefault: false,
    waiterMaxEst: 0,
    rentalMinEst: 0,
    loanerMinEst: 0,
    rentalConcernOnly: 0,
    loanerConcernOnly: 0,
};

export const TestDeptSpec: DepartmentSpec = {
    Advisors: [
        {
            advisorNum: '01',
            advisorName: 'John Tester',
            advisorPhone: '2821192900',
            advisorImage: 'img.reyrey.net',
            defaultFlag: false,
        },
        {
            advisorNum: '001',
            advisorName: 'John Anderson',
            advisorPhone: '2828192819',
            advisorImage: 'www.url.com',
            defaultFlag: false,
        },
        {
            advisorNum: '02',
            advisorName: 'Jane Doe',
            advisorPhone: '2125552900',
            advisorImage: 'img.reyrey.net',
            defaultFlag: true,
        },
    ],
    Transportation: [
        {
            type: '01',
            title: 'Have my own transportation',
            titleEN: 'Have my own transportation',
            titleFR: 'Avoir mon propre transport',
            information: 'Just drop your car off and ride home with a friend.',
            informationEN: 'Just drop your car off and ride home with a friend.',
            informationFR: 'Déposez simplement votre voiture et rentrez chez vous avec un ami.',
            description: '',
            descriptionEN: '',
            descriptionFR: '',
            defaultFlag: false,
        },
    ],
    addtnlInfo: '',
    addtnlInfoEN: '',
    addtnlInfoFR: '',
    advisorOption: '',
    advisorOptionEN: '',
    advisorOptionFR: '',
    allTimesOption: false,
    allwAdvChng: 'Y',
    autoCnfrmAppt: '',
    cntctHrsClose1: [''],
    cntctHrsClose2: [''],
    cntctHrsClose3: [''],
    cntctHrsOpen1: [''],
    cntctHrsOpen2: [''],
    cntctHrsOpen3: [''],
    comingClosures: [''],
    confMessage: '',
    confMessageEN: '',
    confMessageFR: '',
    contactAddr: BlankAddress,
    contactEmail: '',
    contactExt: '',
    contactPhnNum: '',
    contactWebNme: '',
    custUpdateEml: '',
    defAdvOption: '',
    defAdvisorNum: '',
    defTransOption: '',
    defTranspValue: '',
    dispPhoneSel: '',
    dmsAction: [],
    dmsComplete: [],
    dmsCompleteEN: [],
    dmsCompleteFR: [],
    dmsInProgress: [],
    dmsInProgressEN: [],
    dmsInProgressFR: [],
    dmsNotStarted: [],
    dmsNotStartedEN: [],
    dmsNotStartedFR: [],
    dmsWebTitle: [],
    dmsWebTitleEN: [],
    dmsWebTitleFR: [],
    // endTime: '',
    maintMenuDisc: '',
    maintMenuDiscEN: '',
    maintMenuDiscFR: '',
    recTimesCtgry: '',
    recTimesDefCnt: '',
    recommTimes: '',
    disclaimerMsg: '',
    disclaimerMsgEN: '',
    disclaimerMsgFR: '',
    maintMenuDiscFlg: '',
    requireConsFlg: '',
    requireConsMsg: '',
    requireConsMsgEN: '',
    requireConsMsgFR: '',
    // shopClos1: '',
    // shopClose2: '',
    // shopOpen1: '',
    // shopOpen2: '',
    shwCustPrice: '',
    shwIntrnlLines: '',
    shwLinesROhst: '',
    // startTime: '',
    timeOfDay: [
        {
            title: 'Morning',
            titleEN: 'Morning',
            titleFR: 'Matin',
            startTime: '0700',
            endTime: '1145',
            default: false },
        {
            title: 'Afternoon',
            titleEN: 'Afternoon',
            titleFR: 'Après-midi',
            startTime: '1200',
            endTime: '1545',
            default: false },
        {
            title: 'Evening',
            titleEN: 'Evening',
            titleFR: 'Soirée',
            startTime: '1600',
            endTime: '1900',
            default: false },
        {
            title: 'All Day',
            titleEN: 'All Day',
            titleFR: 'Toute la journée',
            startTime: '0700',
            endTime: '1900',
            default: true },
    ],
    shopHours: [
        {
            day: 'Monday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Tuesday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Wednesday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Thursday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Friday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Saturday',
            open1: '0700',
            close1: '2100',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Sunday',
            open1: '0900',
            close1: '1800',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
    ],
    useDealerDisc: '',
    webLeadTimeHrs: '',
    anyAdvDefault: false,
    waiterMaxEst: 0,
    rentalMinEst: 0,
    loanerMinEst: 0,
    rentalConcernOnly: 0,
    loanerConcernOnly: 0,
};

export const BlankSpecs: SpecData = {
    mobileName: '',
    oemTheme: '',
    logImgName: '',
    schApptMsg: '',
    yourAcctMsg: '',
    checkRepairMsg: '',
    emptyCartMsg: '',
    textOptInMsg: '',
    maintSchTabMsg: '',
    indSVCsTabMsg: '',
    writeYourOwnTabMsg: '',
    newVINentryFlag: '',
    skipServicesFlag: false,
    skipSVCMsg: '',
    skipSVCOp: '',
    departmentFlag: '',
    confMsg: '',
    titleTag: '',
    dislaimerMsg: '',
    consentFlag: true,
    consentMsg: '',
    showWeOwes: true,
    showPrvRecom: true,
    showOEMRecall: true,
    otherMakes: true,
    oemServices: '',
    userDefServices: '',
    // showQuickTimes: false,
    // QuickTimesType: '',
    // QuickTimesNum: 0,
    timeOfDay: [],
    //     { title: 'Morning', startTime: '0700', endTime: '1145', default: false },
    //     { title: 'Afternoon', startTime: '1200', endTime: '1545', default: false },
    //     { title: 'Evening', startTime: '1600', endTime: '1900', default: false },
    //     { title: 'All Day', startTime: '0700', endTime: '1900', default: true },
    // ],
    Transportation: [],
    //     {
    //         type: '01',
    //         title: 'Have my own transportation',
    //         information: 'Just drop your car off and ride home with a friend.',
    //         description: '',
    //         defaultFlag: false,
    //     },
    // ],
    Advisors: [],
    //     {
    //         advisorNum: '01',
    //         advisorName: 'John Tester',
    //         advisorPhone: '2821192900',
    //         advisorImage: 'img.reyrey.net',
    //         defaultFlag: false,
    //     },
    //     {
    //         advisorNum: '02',
    //         advisorName: 'Jane Doe',
    //         advisorPhone: '2125552900',
    //         advisorImage: 'img.reyrey.net',
    //         defaultFlag: true,
    //     },
    // ],
    webLeadTimeHrs: 24,
    allowAdvChange: true,
    recommendedTimes: true,
    recommendedTimesDefault: 'A',
    recommendedTimesCount: 5,
    defaultAdvisor: 'A',
    defaultTrans: 'D',
    allowTimes: true,
    allowTimesName: 'No Advisor',
    ShopHours: [],
    //     {
    //         day: 'Monday',
    //         open1: '0700',
    //         close1: '1900',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Tuesday',
    //         open1: '0700',
    //         close1: '1900',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Wednesday',
    //         open1: '0700',
    //         close1: '1900',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Thursday',
    //         open1: '0700',
    //         close1: '1900',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Friday',
    //         open1: '0700',
    //         close1: '1900',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Saturday',
    //         open1: '0700',
    //         close1: '2100',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    //     {
    //         day: 'Sunday',
    //         open1: '0900',
    //         close1: '1800',
    //         open2: '',
    //         close2: '',
    //         open3: '',
    //         close3: '',
    //     },
    // ],
    recallMsg: '',
    allowDoneElsewhere: true,
    weOweMsg: '',
    prevRecomMsg: '',
    recallGreetMsg: '',
    oemRecall: 'N',
    RC: '0000',
    Error: '',
    shwLinesROhst: '',
    bdySpecs: BlankDeptSpec,
    custUpdateEml: '',
    disclaimerMsg: '',
    dispPhoneSel: '',
    dmsAction: [],
    dmsComplete: [],
    dmsInProgress: [],
    dmsNotStarted: [],
    dmsWebTitle: [],
    homeScrnIcnActv: [],
    homeScrnIcon: [],
    maintMenuDisc: [''],
    notifySkip: '',
    offByOpCode: [''],
    reacallLeadTime: '',
    recallNotify: '',
    showDiagnTool: '',
    diagnToolMsg: '',
    showWrtYourOwn: '',
    shwCustPrice: '',
    shwIntrnlLines: '',
    svcSpecs: BlankDeptSpec,
    timeZone: '',
    pdiSpecs: BlankDeptSpec,
    ossSpecs: BlankDeptSpec,
    validMakes: [],
    otherMakesIncFlag: '',
    otherMakesDesc: [],
    faviconURL: '',
    longCode: '',
    logId: '',
    fordSmarttFlag: '',
    kiaTrackingFlag: '',
    gmTrackingFlag: '',
    toyotaTrackingFlag: '',
    lexusTrackingFlag: '',
    gmOneSrcId: '',
    toyotaRetId: '',
    lexusRetId: '',
    // sessionGUID: '',
    smsLaunched: '',
    cancelFlag: '',
    tagManagerId: '',
    mbzTrackingFlag: '',
    mbzRetId: '',
    langOption: '',
    portalLaunched: '',
    eApprovalLaunched: '',
    mfaEnabled: false,
    mazdaCARetId: '',
    mazdaCATrackingFlag: '',
    autoSelRecall: true,
    gmDealerCanRedeem: '',
    gmDealerCanEarn: '',
    myGMRewardsLaunched: '',
    tealiumAccount: '',
    showCustPrice: '',
    showComplaintDef: '',
    showGuestAppt: '',
    hidePriceLabel: '',
    ENMobileName: '',
    FRMobileName: '',
    ENTitleTag: '',
    FRTitleTag: '',
    ENSchedAppt: '',
    FRSchedAppt: '',
    ENYourAcct: '',
    FRYourAcct: '',
    ENCheckRepair: '',
    FRCheckRepair: '',
    ENEmptyCart: '',
    FREmptyCart: '',
    ENTextOptIn: '',
    FRTextOptIn: '',
    ENMaintSchTab: '',
    FRMaintSchTab: '',
    ENIndSVCsTab: '',
    FRIndSVCsTab: '',
    ENWriteYourOwnTab: '',
    FRWriteYourOwnTab: '',
    ENSkipSVCMsg: '',
    FRSkipSVCMsg: '',
    ENoemServices: '',
    FRoemServices: '',
    ENuserDefServices: '',
    FRuserDefServices: '',
    ENweOweMsg: '',
    FRweOweMsg: '',
    ENprevRecomMsg: '',
    FRprevRecomMsg: '',
    ENrecallGreetMsg: '',
    FRrecallGreetMsg: '',
    ENdiagnToolMsg: '',
    FRdiagnToolMsg: '',
    ENrecallMsg: '',
    FRrecallMsg: '',
    toyotaTDMCLaunched: '',
    lexusTDMCLaunched: '',
    vwTrackingFlag: '',
    vwRetId: '',
};

export const TestSpecs: SpecData = {
    mobileName: 'Reynolds Motors',
    oemTheme: 'D',
    logImgName: '',
    schApptMsg: 'Schedule your service appointment with one of our experienced advisors.',
    yourAcctMsg: 'Sign into or create an account to manage and track your vehicle\'s activity while in service.',
    checkRepairMsg: 'Check the real time status of your vehicle while it is in the shop',
    emptyCartMsg: 'Your cart is currently empty',
    textOptInMsg: 'Testing the opt in message',
    maintSchTabMsg: 'Maintenance Schedule',
    indSVCsTabMsg: 'Individual Services',
    writeYourOwnTabMsg: 'Write your Own',
    newVINentryFlag: 'S',
    skipServicesFlag: false,
    skipSVCMsg: '',
    skipSVCOp: 'OPCODE',
    departmentFlag: '',
    confMsg: 'Your Appointment has been made',
    titleTag: 'Service Portal',
    dislaimerMsg: '',
    consentFlag: true,
    consentMsg: '',
    showWeOwes: true,
    showPrvRecom: true,
    showOEMRecall: true,
    otherMakes: true,
    oemServices: '',
    userDefServices: '',
    // showQuickTimes: true,
    // QuickTimesType: 'A',
    // QuickTimesNum: 6,
    timeOfDay: [
        {
            title: 'Morning',
            titleEN: 'Morning',
            titleFR: 'Matin',
            startTime: '0700',
            endTime: '1145',
            default: false },
        {
            title: 'Afternoon',
            titleEN: 'Afternoon',
            titleFR: 'Après-midi',
            startTime: '1200',
            endTime: '1545',
            default: false },
        {
            title: 'Evening',
            titleEN: 'Evening',
            titleFR: 'Soirée',
            startTime: '1600',
            endTime: '1900',
            default: false },
        {
            title: 'All Day',
            titleEN: 'All Day',
            titleFR: 'Toute la journée',
            startTime: '0700',
            endTime: '1900',
            default: true },
    ],
    Transportation: [
        {
            type: '',
            title: 'Have my own transportation',
            titleEN: 'Have my own transportation',
            titleFR: 'Avoir mon propre transport',
            information: '',
            informationEN: '',
            informationFR: '',
            description: 'Just drop your car of and ride home with a friend.',
            descriptionEN: 'Just drop your car of and ride home with a friend.',
            descriptionFR: 'Déposez simplement votre voiture et rentrez chez vous avec un ami.',
            defaultFlag: false,
        },
        {
            type: 'W',
            title: 'Wait at Dealership',
            titleEN: 'Wait at Dealership',
            titleFR: 'Attendre chez le concessionnaire',
            information: 'Wait at the dealership.  Use our FREE WIFI to work, play games or watch movies',
            informationEN: 'Wait at the dealership.  Use our FREE WIFI to work, play games or watch movies',
            informationFR: 'Attendre chez le concessionnaire.  Utilisez notre WIFI GRATUIT pour travailler',
            description: 'You can wait at a dealership if you choose.',
            descriptionEN: 'You can wait at a dealership if you choose.',
            descriptionFR: 'Vous pouvez attendre chez un concessionnaire si vous le souhaitez.',
            defaultFlag: false,
        },
        {
            type: '03',
            title: 'Loaner',
            titleEN: 'Loaner',
            titleFR: 'Prêt',
            information: 'No worries.  We have just the right car for you.',
            informationEN: 'No worries.  We have just the right car for you.',
            informationFR: 'Pas de soucis.  Nous avons la voiture qu\'il vous faut.',
            description: '',
            descriptionEN: '',
            descriptionFR: '',
            defaultFlag: true,
        },
        {
            type: '04',
            title: 'Shuttle',
            titleEN: 'Shuttle',
            titleFR: 'Navette',
            information: 'Take our shuttle.  We can drop you off at home, work or the mall',
            informationEN: 'Take our shuttle.  We can drop you off at home, work or the mall',
            informationFR: 'Prenez notre navette.  Nous pouvons vous déposer chez vous, au travail ou au centre commercial',
            description: '',
            descriptionEN: '',
            descriptionFR: '',
            defaultFlag: false,
        },
        {
            type: '05',
            title: 'Night Drop',
            titleEN: 'Night Drop',
            titleFR: 'Dépôt de nuit',
            information: 'Drop your keys in the drop box and we will contact you tomorrow',
            informationEN: 'Drop your keys in the drop box and we will contact you tomorrow',
            informationFR: 'Déposez vos clés dans la boîte de dépôt et nous vous contacterons demain',
            description: '',
            descriptionEN: '',
            descriptionFR: '',
            defaultFlag: false,
        },
        {
            type: '06',
            title: '',
            titleEN: '',
            titleFR: '',
            information: '',
            informationEN: '',
            informationFR: '',
            description: '',
            descriptionEN: '',
            descriptionFR: '',
            defaultFlag: false,
        },
    ],
    Advisors: [
        {
            advisorNum: '01',
            advisorName: 'John Tester',
            advisorPhone: '2821192900',
            advisorImage: 'img.reyrey.net',
            defaultFlag: false,
        },
        {
            advisorNum: '02',
            advisorName: 'Jane Doe',
            advisorPhone: '2125552900',
            advisorImage: 'img.reyrey.net',
            defaultFlag: true,
        },
        {
            advisorNum: '999',
            advisorName: 'Some Body',
            advisorPhone: '2125552900',
            advisorImage: 'img.reyrey.net',
            defaultFlag: true,
        },
    ],
    webLeadTimeHrs: 24,
    allowAdvChange: true,
    recommendedTimes: true,
    recommendedTimesDefault: 'A',
    recommendedTimesCount: 5,
    defaultAdvisor: 'A',
    defaultTrans: 'D',
    allowTimes: true,
    allowTimesName: 'No Advisor',
    ShopHours: [
        {
            day: 'Monday',
            open1: '0700',
            close1: '1000',
            open2: '',
            close2: '1300',
            open3: '',
            close3: '1700',
        },
        {
            day: 'Tuesday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Wednesday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Thursday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Friday',
            open1: '0700',
            close1: '1900',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Saturday',
            open1: '0700',
            close1: '2100',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
        {
            day: 'Sunday',
            open1: '0900',
            close1: '1800',
            open2: '',
            close2: '',
            open3: '',
            close3: '',
        },
    ],
    recallMsg: 'This is a TEST recall message',
    allowDoneElsewhere: true,
    weOweMsg: 'This is a TEST we owe message',
    prevRecomMsg: 'This is a TEST previously recommended message',
    recallGreetMsg: 'This is a TEST recall greeting message',
    oemRecall: 'N',
    RC: '0000',
    Error: '',
    shwLinesROhst: '',
    bdySpecs: BlankDeptSpec,
    custUpdateEml: '',
    disclaimerMsg: '',
    dispPhoneSel: '',
    dmsAction: [],
    dmsComplete: [],
    dmsInProgress: [],
    dmsNotStarted: [],
    dmsWebTitle: [],
    homeScrnIcnActv: [],
    homeScrnIcon: [],
    maintMenuDisc: [''],
    notifySkip: '',
    offByOpCode: [''],
    reacallLeadTime: '',
    recallNotify: '',
    showDiagnTool: 'Y',
    diagnToolMsg: '',
    showWrtYourOwn: 'Y',
    shwCustPrice: '',
    showGuestAppt: '',
    hidePriceLabel: '',
    shwIntrnlLines: '',
    svcSpecs: BlankDeptSpec,
    timeZone: '',
    pdiSpecs: BlankDeptSpec,
    ossSpecs: BlankDeptSpec,
    validMakes: [],
    otherMakesIncFlag: '',
    otherMakesDesc: [],
    faviconURL: '',
    longCode: '123-456-7890',
    logId: '',
    fordSmarttFlag: '',
    kiaTrackingFlag: '',
    gmTrackingFlag: '',
    toyotaTrackingFlag: '',
    lexusTrackingFlag: 'Y',
    gmOneSrcId: '',
    toyotaRetId: '',
    lexusRetId: '',
    // sessionGUID: '',
    smsLaunched: 'Y',
    cancelFlag: '',
    tagManagerId: '',
    mbzTrackingFlag: '',
    mbzRetId: '',
    langOption: '',
    portalLaunched: 'Y',
    eApprovalLaunched: 'Y',
    mfaEnabled: false,
    mazdaCARetId: '',
    mazdaCATrackingFlag: '',
    autoSelRecall: true,
    gmDealerCanRedeem: '',
    gmDealerCanEarn: '',
    myGMRewardsLaunched: '',
    tealiumAccount: '',
    showCustPrice: '',
    showComplaintDef: '',
    ENMobileName: 'Eng Reynolds Motors',
    FRMobileName: 'French Reynolds Motors',
    ENTitleTag: 'Service Portal',
    FRTitleTag: 'Portail de service',
    ENSchedAppt: 'Schedule Appointment',
    FRSchedAppt: 'Prendre rendez-vous',
    ENYourAcct: 'Your Account',
    FRYourAcct: 'Votre compte',
    ENCheckRepair: 'Check Repair Status',
    FRCheckRepair: 'Vérifier le statut de la réparation',
    ENEmptyCart: 'Your cart is empty',
    FREmptyCart: 'Votre panier est vide',
    ENTextOptIn: 'Text Opt In',
    FRTextOptIn: 'French Text Opt In',
    ENMaintSchTab: 'Maintenance Schedule',
    FRMaintSchTab: 'Calendrier de maintenance',
    ENIndSVCsTab: 'Individual Services',
    FRIndSVCsTab: 'Services individuels',
    ENWriteYourOwnTab: 'Write Your Own',
    FRWriteYourOwnTab: 'Écrivez le vôtre',
    ENSkipSVCMsg: '',
    FRSkipSVCMsg: '',
    ENoemServices: '',
    FRoemServices: '',
    ENuserDefServices: '',
    FRuserDefServices: '',
    ENweOweMsg: '',
    FRweOweMsg: '',
    ENprevRecomMsg: '',
    FRprevRecomMsg: '',
    ENrecallGreetMsg: '',
    FRrecallGreetMsg: '',
    ENdiagnToolMsg: '',
    FRdiagnToolMsg: '',
    ENrecallMsg: '',
    FRrecallMsg: '',
    toyotaTDMCLaunched: '',
    lexusTDMCLaunched: '',
    vwTrackingFlag: '',
    vwRetId: '',
};


export const TestAdvisor: Advisor = {
    advisorNum: '02',
    advisorName: 'Jane Doe',
    advisorPhone: '2125552900',
    advisorImage: 'img.reyrey.net',
    defaultFlag: true,
};

export const TestTransportation: Transportation = {
    type: '01',
    title: 'Have my own transportation',
    titleEN: 'Have my own transportation',
    titleFR: 'Avoir mon propre transport',
    information: 'Just drop your car off and ride home with a friend.',
    informationEN: 'Just drop your car off and ride home with a friend.',
    informationFR: 'Déposez simplement votre voiture et rentrez chez vous avec un ami.',
    description: '',
    descriptionEN: '',
    descriptionFR: '',
    defaultFlag: false,
};

export const BlankServiceDocsSpecs: ServiceDocsData = {
    enabled: false,
    documents: [],
    includeHistory: false,
    dealerName: '',
    servicePhone: '',
    footer: '',
    availMsg: '',
    useProfile: false,
    theme: '',
    logoURL: '',
    backgroundURL: '',
    faviconURL: '',
    titleTag: '',
    docToken: '',
    osdProfile: '',
    osdFordSmarttFlag: '',
    osdVerifyIdentityFlag: false,
};

export const TestServiceDocsSpecs: ServiceDocsData = {
    enabled: true,
    documents: [
        {
            publish: true,
            type: 'RO',
            displayName: 'Repair Order',
            description: 'The initial write up from your Advisor',
        },
        {
            publish: true,
            type: 'SE',
            displayName: 'Estimate',
            description: 'Estimated pricing for your repairs',
        },
        {
            publish: true,
            type: 'MM',
            displayName: 'Suggested Maintenance',
            description: 'Review suggested maintenance items',
        },
        {
            publish: true,
            type: 'VI',
            displayName: 'Vehicle Inspection',
            description: 'A visual markup of any pre-existing issues',
        },
        {
            publish: true,
            type: 'RC',
            displayName: 'Multi-Point Inspection',
            description: 'A comprehensive inspection of your vehicle',
        },
        {
            publish: true,
            type: 'VC',
            displayName: 'Vehicle Condition Report',
            description: 'A comprehensive write up of your visit',
        },
        {
            publish: true,
            type: 'IN',
            displayName: 'Invoice',
            description: 'Review the invoice from your visit',
        },
        {
            publish: true,
            type: 'IV',
            displayName: 'Pictures/Videos',
            description: 'Pictures/videos associated with your repairs',
        },
    ],
    includeHistory: true,
    dealerName: 'Reyrey Special Sauce',
    servicePhone: '123456789',
    footer: 'Contact the dealership with questions about your service documents.',
    // availMsg: 'Documents will be available on this page for a limited time.
    // Please Save or Print any documents that you would like to retain for your records.',
    availMsg: 'Documents will be available on this page for a limited time.',
    useProfile: false,
    theme: 'D',
    logoURL: '',
    backgroundURL: '',
    faviconURL: '',
    titleTag: 'View Service Documents',
    docToken: '',
    osdProfile: '10',
    osdFordSmarttFlag: '',
    osdVerifyIdentityFlag: false,
};